const responsiveGridImagesPerRows = (screenWidth, max) => {
    if (screenWidth <= 600) {
        return 2
    }
    if (screenWidth <= 800) {
        return 3
    }
    if (screenWidth <= 1200) {
        return max - 2
    }
    if (screenWidth <= 1600) {
        return max - 1
    }
    return max
}


const GetDocumentCover = document => {
    switch (document.Type) {
        case "Photo":
            if (document.HD && document.HD.Url) {
                return document.HD.Url
            }
            return document.Standard.Url
        case "Video":
            return document.Thumbnail.Url
        default:
            return ""
    }
};

const GetDocumentFileToDownload = document => {
    switch (document.Type) {
        case "Photo":
            if (document.HD && document.HD.Url) {
                return document.HD.Url
            }
            return document.Standard.Url
        case "Video":
            return document.Standard.Url
        default:
            return ""
    }
};

const sortDocuments = documentPlaylists => {
    return [...documentPlaylists].sort((playlist1, playlist2) => {
        if (playlist1.DocumentOrder > playlist2.DocumentOrder) return 1;
        return -1;
    });
};

const socialCompleteURL = (social, username) => {
    //TODO: add more socials
    let link = "";
    switch (social.toLowerCase()) {
        case "modelscom":
            if (username.includes("models/")) {
                link = `https://www.models.com/${username}`;
            } else {
                link = `https://www.models.com/models/${username}`;
            }
            break;
        case "imdb":
            link = `https://www.imdb.com/name/${username}`;
            break;
        case "youtube":
            link = `https://www.youtube.com/channel/${username}`;
            break;
        case "tiktok":
            link = `https://www.tiktok.com/@${username}`;
            break;
        default:
            link = `https://www.${social.toLowerCase()}.com/${username}`;
    }
    return link;
};

const getThumbnailWidth = (media, thumbheight) => {
    const ratio = media.Height / thumbheight;
    return media.Width / ratio;
};

export {
    GetDocumentCover,
    GetDocumentFileToDownload,
    sortDocuments,
    socialCompleteURL,
    getThumbnailWidth,
    responsiveGridImagesPerRows
};
